/** 門店首頁智能推薦（Overseas patch 456） */
export const STORE_HOME_FEED_MENU_IDS = {
  desk: 991220,
  view: 991221,
  save: 991222
}

export default STORE_HOME_FEED_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storeHomeFeed.js